import { observable, action, computed } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'

class BlogStore {

    @observable activeBlogPosts
    @observable activeOffers

    constructor() {
        this.offerId = "h2nzK0zWrt"
        this.blogId = "sxVTzzDqfa"

        this.blogImage = null
        this.blogText = null
        this.blogTitle = null

        this.activeBlogPosts = []
        this.activeOffers = []
    }

    @computed get isActiveBlogPosts() {
        return this.activeBlogPosts && this.activeBlogPosts[0] ? true : false
    }

    @computed get isActiveOffers() {
        return this.activeOffers && this.activeOffers[0] ? true : false
    }

    @action setActiveBlogPosts = (activeBlogPosts) => {
        this.activeBlogPosts = activeBlogPosts
    }

    deleteBlogPost = (objectId) => {
        let BlogPost = Parse.Object.extend("BlogPost");
        var blogPost = new BlogPost();

        blogPost.set("objectId", objectId);
        blogPost.destroy().then(response => {
            this.getActiveBlogPosts()
            this.getActiveOffers()
        }).catch(err => {
            console.error(err)
        })
    }

    getActiveOffers = () => {
        let blogPostQuery = new Parse.Query("BlogPost")
        let blogPosts = []
        let highlightedBlogPosts = []
        blogPostQuery.equalTo("isActive", true)

        blogPostQuery.each(blogPost => {
            if (blogPost.toJSON().categories[0] === this.offerId) {
                if (blogPost.toJSON().isHighlighted === true) {
                    highlightedBlogPosts.push(blogPost.toJSON())
                    
                } else {
                    blogPosts.push(blogPost.toJSON())

                }
            }
        }).then(response => {
            blogPosts = _.sortBy(blogPosts, 'createdAt')
            highlightedBlogPosts = _.sortBy(highlightedBlogPosts, 'updatedAt')

            let newArray = blogPosts.concat(highlightedBlogPosts)

            this.activeOffers = newArray
        }).catch(err => {
            console.error("err", err)
        })
    }

    getActiveBlogPosts = () => {
        this.setActiveBlogPosts([])
        let blogPostQuery = new Parse.Query("BlogPost")
        let blogPosts = []
        let highlightedBlogPosts = []
        blogPostQuery.equalTo("isActive", true)

        blogPostQuery.each(blogPost => {
            if (blogPost.toJSON().categories[0] === this.blogId) {
                if (blogPost.toJSON().isHighlighted === true) {
                    highlightedBlogPosts.push(blogPost.toJSON())
                    
                } else {
                    blogPosts.push(blogPost.toJSON())

                }
            }
        }).then(response => {
            blogPosts = _.sortBy(blogPosts, 'createdAt')
            highlightedBlogPosts = _.sortBy(highlightedBlogPosts, 'updatedAt')

            let newArray = blogPosts.concat(highlightedBlogPosts)
            this.setActiveBlogPosts(newArray)
            //this.setActiveBlogPosts(blogPosts)
        }).catch(err => {
            console.error("err", err)
        })
    }

    saveBlogPost = (blogPost) => {
        this.blogImage = blogPost.blogImage
        this.blogText = blogPost.blogText
        this.blogTitle = blogPost.blogTitle

        const BlogPostParseObj = Parse.Object.extend("BlogPost")

        let newBlogPost = new BlogPostParseObj()
        newBlogPost.set("title", this.blogTitle)
        newBlogPost.set("image", this.blogImage)
        newBlogPost.set("text", this.blogText)
        newBlogPost.set("categories", [blogPost.blogCategory === "offer" ? this.offerId : this.blogId])
        newBlogPost.set("isActive", true)
        newBlogPost.save().then(response => {
            this.getActiveBlogPosts()
            this.getActiveOffers()
        })
    }

    highlightBlogPost = (objectId) => {
        let query = new Parse.Query("BlogPost");

        query.equalTo("objectId", objectId);

        query.each(function(obj) {

            obj.set("isHighlighted", !obj.toJSON().isHighlighted)
            
            return obj.save();

        }).then( resp => {
            this.getActiveBlogPosts()
            this.getActiveOffers()

        })
    }


    editBlogPost = (blogPost) => {
        let query = new Parse.Query("BlogPost");

        query.equalTo("objectId", blogPost.objectId);

        query.each(function(obj) {
            obj.set("title", blogPost.blogTitle)
            obj.set("image", blogPost.blogImage)
            obj.set("text", blogPost.blogText)

            return obj.save();
        }).then( resp => {
            this.getActiveBlogPosts()
            this.getActiveOffers()

        })
    }
}

const store = new BlogStore()
export default store



// WEBPACK FOOTER //
// /src/stores/BlogStore.js